import { graphql, useStaticQuery } from "gatsby";
import { filter } from "lodash";
import { useMemo } from "react";

import { useExcludeFromLanguage } from "~/hooks/utils/useAllDataHelper";

const useAllArticleData = () => {
    const {
        allWpArticle,
        allWpArticleTopic,
        allWpArticleType,
        allWpDlmdownloadArticles,
    } = useStaticQuery(graphql`
        {
            allWpArticle(sort: { date: DESC }) {
                nodes {
                    ...ArticleFragment
                }
            }
            allWpArticleTopic {
                nodes {
                    slug
                    termTaxonomyId
                    taxonomyDetails {
                        hideFromFilter
                        translatedName {
                            languageCode
                            translation
                        }
                    }
                    name
                    ancestors {
                        nodes {
                            name
                            slug
                        }
                    }
                    wpChildren {
                        nodes {
                            name
                            slug
                            taxonomyDetails {
                                hideFromFilter
                                translatedName {
                                    languageCode
                                    translation
                                }
                            }
                        }
                    }
                }
            }
            allWpArticleType {
                nodes {
                    name
                    slug
                    termTaxonomyId
                    taxonomyDetails {
                        hideFromFilter
                        translatedName {
                            languageCode
                            translation
                        }
                    }
                }
            }
            allWpDlmdownloadArticles: allWpDlmdownload(
                filter: {
                    documentsAttributes: { showInKnowledgeCenter: { eq: true } }
                }
            ) {
                nodes {
                    ...DocumentFragment
                    documentsAttributes {
                        knowledgeCenterDate
                        primaryTopic {
                            name
                            slug
                            termTaxonomyId
                        }
                    }
                    articleTopics {
                        nodes {
                            link: uri
                            name
                            slug
                        }
                    }
                    articleTypes {
                        nodes {
                            link: uri
                            name
                            slug
                        }
                    }
                }
            }
        }
    `);

    const filteredArticles = useExcludeFromLanguage(allWpArticle.nodes);

    const allWpArticleEnglish = useMemo(() => {
        return filter(filteredArticles, {
            languageCode: "en",
        });
    }, [filteredArticles]);

    return {
        allWpArticle: filteredArticles,
        allWpArticleEnglish,
        allWpArticleTopic,
        allWpArticleType,
        allWpDlmdownloadArticles,
    };
};

export default useAllArticleData;
